// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndiaZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || zipcodeValue.trim() === '')
    return { id: 'empty' };
  else if (!/^\d{6}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
